import { PropsWithChildren } from "react";
import { Dialog as ArkDialog, Portal } from "@ark-ui/react";

import "./dialog.css";

interface DialogProps {
  onClose?: VoidFunction;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

const Dialog = ({
  onClose,
  open,
  onOpenChange,
  children,
}: PropsWithChildren<DialogProps>) => {
  return (
    <ArkDialog.Root
      open={open}
      onOpenChange={onOpenChange ? (details) => onOpenChange(details.open) : undefined}
      onExitComplete={onClose}
      lazyMount
      unmountOnExit
    >
      <Portal>
        {/*
          data-no-drag: the dialog is portaled to <body>, but React events still
          bubble through the React tree to the grid item that renders it, which
          would start a react-grid-layout drag. RGL's draggableCancel="[data-no-drag]"
          walks the target's DOM ancestors, so marking the portaled nodes cancels it.
        */}
        <ArkDialog.Backdrop data-no-drag />
        <ArkDialog.Positioner data-no-drag>{children}</ArkDialog.Positioner>
      </Portal>
    </ArkDialog.Root>
  );
};

Dialog.Content = ArkDialog.Content;

export default Dialog;
